<template>
   <div id="app-content" :class="'app-content-tmpl-' + $store.getters.getData.template1" v-bg="{image: $store.getters.getData.background, alternative: true, dir: null}">

    <SideMenu v-if="$store.getters.platform === 'browser'" />
    <nav-bar></nav-bar>
    <router-view/>

    <footer>
      <a v-if="$store.getters.getData.email_contact" :href="'mailto:' + $store.getters.getData.email_contact" target="_blank">{{ $i18n.t('FOOTER.CONTACT') }}</a>
      <a v-if="$store.getters.getData.external_pay_method === 'EPO'" href="https://epoch.com/" target="_blank">{{ $i18n.t('FOOTER.BILLING-SUPPORT') }}</a>
      <router-link v-if="$store.getters.getData.legal_warning" to="/legal-warning">{{ $i18n.t('FOOTER.LEGAL-WARNING') }}</router-link>
      <router-link v-if="$store.getters.getData.privacy_policy" to="/privacy-policy">{{ $i18n.t('FOOTER.PRIVACY-POLICY') }}</router-link>
      <router-link v-if="$store.getters.getData.cookies_policy" to="/cookies-policy">{{ $i18n.t('FOOTER.COOKIES-POLICY') }}</router-link>
      <router-link v-if="$store.getters.getData.compliance" to="/compliance">18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement</router-link>
    </footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import SideMenu from '@/components/SideMenu.vue'

export default {
  name: 'AppContent',
  components: {
    'nav-bar': Navbar,
    SideMenu
  },
  created: function () {
    if (this.$store.getters.getData.is_close) {
      if (!this.$store.getters.user) {
        this.$router.push({name: 'login-browser'})
      } else if (this.$store.getters.getData.is_subscriptions && !this.$store.getters.user.subscriptions.length) {
        this.$router.push({name: 'subcription-error'})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
// CUIDADO!!!  estos estilos se aplican a todo (no scoped)

// FONTS
@font-face
    font-family: "Roboto";
    src: url('../../assets/fonts/Roboto-Regular.ttf') format("truetype");

@font-face
    font-family: "Roboto Light";
    src: url('../../assets/fonts/Roboto-Light.ttf') format("truetype");

@font-face
  font-family: "OpenSans";
  src: url('../../assets/fonts/OpenSans-Regular.ttf') format("truetype");

#app-content
  font-family: Roboto, sans-serif;
  position: absolute
  top: 0
  lelf: 0;
  width: 100%;
  min-height: 100%;

  background: url("../../assets/images/background-default.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  padding-bottom: 2rem

// PLANTILLA CANAL SUR
#app-content.app-content-tmpl-SUR
  background-image: url('../../assets/images/background-default-dark.jpg')

  font-family: OpenSans, sans-serif;
  font-synthesis: none;
  font-feature-settings: 'kern';
  -moz-font-feature-settings: 'kern';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: rgba(255,255,255,.9);

  .wrapper #overlay-text
      margin-top: 9rem!important;

  // listas
  .list-SUR
    padding-right: 3vw
    backdrop-filter: blur(5px)

    h3
      margin-block-start: 0.67em;
      margin-block-end: 0.67em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      margin-bottom: .9rem;
      font-weight: 500;
      line-height: 1.23;

    .item
      margin: 0rem 0.9rem 0rem 0rem

      .image
        background-position: center center
        background-repeat: no-repeat
        background-size: cover
        opacity: 0
        transition: opacity .2s linear
        border-radius: 10px

      .image:after
        content: "";
        display: block;
        position: absolute;
        top: 10px;
        left: 10px;
        right: 10px;
        bottom: 30px;
        z-index: -1;
        background-color: black;
        -webkit-filter: blur(20px);

      .text
        font-size: 1.1rem;
        color: #fff;
        // display: inline-block;
        // display: -webkit-box;
        -webkit-line-clamp: 2; // max nb lines to show
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal
        border-radius: 0 0 2px 2px;
        padding-top: 0.5em;
        font-weight: 500;
        line-height: 1.3em;
        height: 3em;
        text-align: center;
        background: transparent!important

#app-content footer
  position: absolute
  bottom: 0
  left: 0
  right: 0
  padding: 1rem
  background-color: rgba(0, 0, 0, 0.75)
  border-top: 1px solid #e7e7e7

  display: flex
  justify-content: center
  flex-wrap: wrap

  a:link , a:visited, a:active
    color: #A3A3A3
    font-size: .6rem
    text-decoration: none
    text-align: center
    margin: 0 1rem

  a:hover
    text-decoration: underline;

@media (max-width: 768px)
  #app-content
    padding-bottom: 8rem!important
</style>



// WEBPACK FOOTER //
// src/pages/site/AppContent.vue